import React from 'react'
import styles from './FilePreview.module.scss'

const SoundIcon = () => {
    return (

        <svg className={styles.soundIcon} data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 386.16 231.82">

            <rect className="si-r" x="0" y="92.07" width="15.88" height="47.4" rx="7.94" ry="7.94" />
            <rect className="si-r" x="30.63" y="69.37" width="15.88" height="93.13" rx="7.94" ry="7.94" />
            <rect className="si-r" x="62.16" y="38.52" width="15.88" height="154.29" rx="7.94" ry="7.94" />
            <rect className="si-r" x="92.8" y="69.26" width="15.88" height="93.35" rx="7.94" ry="7.94" />
            <rect className="si-r" x="123.43" y="38.68" width="15.88" height="154.23" rx="7.94" ry="7.94" />
            <rect className="si-r" x="154.51" y="0" width="15.88" height="231.82" rx="7.94" ry="7.94" />
            <rect className="si-r" x="185.59" y="38.35" width="15.88" height="155.68" rx="7.94" ry="7.94" />
            <rect className="si-r" x="215.78" y="69.2" width="15.88" height="92.85" rx="7.94" ry="7.94" />
            <rect className="si-r" x="246.75" y="91.9" width="15.88" height="47.57" rx="7.94" ry="7.94" />
            <rect className="si-r" x="277.71" y="69.32" width="15.88" height="92.74" rx="7.94" ry="7.94" />
            <rect className="si-r" x="308.57" y="38.57" width="15.88" height="153.22" rx="7.94" ry="7.94" />
            <rect className="si-r" x="339.43" y="69.2" width="15.88" height="92.85" rx="7.94" ry="7.94" />
            <rect className="si-r" x="370.29" y="92.35" width="15.88" height="47.35" rx="7.94" ry="7.94" />
        </svg>
    )
}

export default SoundIcon
